/*
* PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
* Copyright (c) 2017 Pearson Education, Inc.
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains the property of
* Pearson Education, Inc. The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
* and Foreign Patents, patent applications, and are protected by trade secret
* or copyright law. Dissemination of this information, reproduction of this
* material, and copying or distribution of this software is strictly forbidden
* unless prior written permission is obtained from Pearson Education, Inc.
*/
import React from 'react'
import { string, array, func } from 'prop-types'
import Icon from '../Icon'
import './select.scss'

const SelectList = ({ id, label, options, styling, handleChange }) => {
  const content = options.map((option, index) => (
    <option key={index} value={option.value}>{option.display}</option>))
  return (
    <div>
      <label className='pe-textLabelInput__label' htmlFor={id}>{label}</label>
      <div className={'pe-select-container ' + styling}>
        <select id={id} className='pe-selectInput--basic' onChange={e => handleChange(e.target.value)}>
          {content}
        </select>
        <Icon fileName='dropdown-open-sm-24' />
      </div>
    </div>
  )
}

SelectList.propTypes = {
  id: string.isRequired,
  label: string,
  options: array.isRequired,
  handleChange: func,
  styling: string
}

SelectList.defaultProps = {
  label: '',
  styling: '',
  handleChange: () => void (0)
}
export default SelectList
